/**
 * 
 * @description 仅暴露 lodash 的一些常用函数
 * 分类 array，collection，function，number，object，string，utility
 */

module.exports = {
    /**
     * 将 array 拆分成多个 size 长度的块，把这些块组成一个新数组。
     * 如果 array 无法被分割成全部等长的块，那么最后剩余的元素将组成一个块。
     */
    'chunk': require('lodash-compat/array/chunk'),

    /**
     * 创建一个新数组并包含原数组中所有的非假值元素。例如 false、null、 0、""、undefined 和 NaN 都是“假值”。
     */
    'compact': require('lodash-compat/array/compact'),

    /**
     *
     */
    'difference': require('lodash-compat/array/difference'),

    /**
     * 可以理解为将嵌套数组的维数减少，flattened（平坦）.
     * 如果 isDeep 值为 true 时，嵌套数组将递归为一维数组, 否则只减少嵌套数组一个级别的维数
     */
    'flatten': require('lodash-compat/array/flatten'),

    /**
     * 创建一个惟一值数组,顺序,从所有的数组使用SameValueZero提供平等的比较
     */
    'union': require('lodash-compat/array/union'),

    /**
     *
     */
    'sortBy': require('lodash-compat/collection/sortBy'),

    /**
     *
     */
    'sortByAll': require('lodash-compat/collection/sortByAll'),

    /**
     *
     */
    'sortByOrder': require('lodash-compat/collection/sortByOrder'),

    /**
     *
     */
    'after': require('lodash-compat/function/after'),

    /**
     *
     */
    'before': require('lodash-compat/function/before'),

    /**
     *
     */
    'curry': require('lodash-compat/function/curry'),

    /**
     *
     */
    'curryRight': require('lodash-compat/function/curryRight'),

    /**
     *
     */
    'debounce': require('lodash-compat/function/debounce'),

    /**
     *
     */
    'defer': require('lodash-compat/function/defer'),

    /**
     *
     */
    'delay': require('lodash-compat/function/delay'),

    /**
     *
     */
    'once': require('lodash-compat/function/once'),

    /**
     *
     */
    'spread': require('lodash-compat/function/spread'),

    /**
     *
     */
    'throttle': require('lodash-compat/function/throttle'),

    /**
     *
     */
    'random': require('lodash-compat/number/random'),

    /**
     *
     */
    'forIn': require('lodash-compat/object/forIn'),

    /**
     *
     */
    'forOwn': require('lodash-compat/object/forOwn'),

    /**
     *
     */
    'get': require('lodash-compat/object/get'),

    /**
     *
     */
    'has': require('lodash-compat/object/has'),

    /**
     *
     */
    'omit': require('lodash-compat/object/omit'),

    /**
     *
     */
    'pick': require('lodash-compat/object/pick'),

    /**
     *
     */
    'set': require('lodash-compat/object/set'),

    /**
     *
     */
    'camelCase': require('lodash-compat/string/camelCase'),

    /**
     *
     */
    'capitalize': require('lodash-compat/string/capitalize'),

    /**
     *
     */
    'escape': require('lodash-compat/string/escape'),

    /**
     *
     */
    'escapeRegExp': require('lodash-compat/string/escapeRegExp'),

    /**
     *
     */
    'kebabCase': require('lodash-compat/string/kebabCase'),

    /**
     *
     */
    'pad': require('lodash-compat/string/pad'),

    /**
     *
     */
    'padLeft': require('lodash-compat/string/padLeft'),

    /**
     *
     */
    'padRight': require('lodash-compat/string/padRight'),

    /**
     *
     */
    'repeat': require('lodash-compat/string/repeat'),

    /**
     *
     */
    'snakeCase': require('lodash-compat/string/snakeCase'),

    /**
     *
     */
    'startCase': require('lodash-compat/string/startCase'),

    /**
     *
     */
    'template': require('lodash-compat/string/template'),

    /**
     *
     */
    'templateSettings': require('lodash-compat/string/templateSettings'),

    /**
     *
     */
    'trunc': require('lodash-compat/string/trunc'),

    /**
     *
     */
    'unescape': require('lodash-compat/string/unescape'),

    /**
     *
     */
    'words': require('lodash-compat/string/words'),

    /**
     *
     */
    'identity': require('lodash-compat/utility/identity'),

    /**
     *
     */
    'noop': require('lodash-compat/utility/noop'),


    /**
     *
     */
    'range': require('lodash-compat/utility/range'),

    /**
     *
     */
    'times': require('lodash-compat/utility/times'),

    /**
     *
     */
    'uniqueId': require('lodash-compat/utility/uniqueId')
};



//////////////////
// WEBPACK FOOTER
// ./src/core/lodash.js
// module id = 34
// module chunks = 0